import hypercardBg from "@/common/assets/images/background-glass.png";
import { format, startOfMonth } from "date-fns";
import { useMemo } from "react";
import { Skeleton } from "@/components/ui/skeleton";
import { useAdminReimbursementsTimeSavedInSecondsQuery } from "@common/utils/graphql";
import { TileHeader } from "../components/TileHeader";
import { DashboardTile } from "../components/DashboardTile";
import commaNumber from "comma-number";

export const TimeSavedTile = () => {
  const { loading: timeSavedTotalLoading, data: timeSavedTotalRaw } =
    useAdminReimbursementsTimeSavedInSecondsQuery({});

  const { loading: timeSavedMonthLoading, data: timeSavedMonthRaw } =
    useAdminReimbursementsTimeSavedInSecondsQuery({
      variables: {
        createdAfter:
          format(startOfMonth(new Date()), "yyyy-MM-dd") + "T23:59:59.999Z",
      },
    });

  const daysSavedTotal = useMemo(() => {
    if (
      timeSavedTotalRaw?.adminReimbursementsTimeSavedInSeconds?.__typename !==
      "QueryAdminReimbursementsTimeSavedInSecondsSuccess"
    ) {
      return 0;
    }
    return Math.ceil(
      timeSavedTotalRaw.adminReimbursementsTimeSavedInSeconds.data /
        (60 * 60 * 24),
    );
  }, [timeSavedTotalRaw]);

  const daysSavedMonth = useMemo(() => {
    if (
      timeSavedMonthRaw?.adminReimbursementsTimeSavedInSeconds?.__typename !==
      "QueryAdminReimbursementsTimeSavedInSecondsSuccess"
    ) {
      return 0;
    }
    return Math.ceil(
      timeSavedMonthRaw.adminReimbursementsTimeSavedInSeconds.data /
        (60 * 60 * 24),
    );
  }, [timeSavedMonthRaw]);

  return (
    <DashboardTile
      className="h-[300px] w-full"
      style={{
        background: `url(${hypercardBg}) 0 0 no-repeat`,
        backgroundPosition: "bottom right",
        backgroundSize: "cover",
      }}
    >
      <TileHeader>TIME SAVED WAITING FOR REIMBURSEMENTS</TileHeader>
      <div className="pb-15 flex h-full flex-col justify-center pb-6">
        {timeSavedMonthLoading || timeSavedTotalLoading ? (
          <>
            <Skeleton className="h-[60px] w-[350px]" />
            <Skeleton className="mt-5 h-[60px] w-[350px]" />
          </>
        ) : (
          <>
            <div className="mt-3	 pb-2 font-serif text-4xl font-medium">
              {`${commaNumber(daysSavedMonth)} ${
                daysSavedMonth === 1 ? "day" : "days"
              }`}
            </div>
            <TileHeader>SAVED THIS MONTH</TileHeader>
            <div className="mt-3	 pb-2 pt-2 font-serif text-4xl font-medium">
              {`${commaNumber(daysSavedTotal)} ${
                daysSavedTotal === 1 ? "day" : "days"
              }`}
            </div>
            <TileHeader>SAVED IN TOTAL</TileHeader>
          </>
        )}
      </div>
    </DashboardTile>
  );
};
